module.exports = __webpack_public_path__ + "img/03.716a1558.png";